import useRequestTable from 'app/hooks/useRequestTable'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import requests from 'app/requests/Opportunity/Opportunity.requests'

import {
    LeaseType,
} from 'app/enums/label.enums'
import {
    OpportunityFilterRequestResponse,
} from '../Opportunity.types'

export default (accountId: number, {
    filters,
}: {
    filters?: {
        accountLaneGroupLeaseType?: LeaseType
    }
} = {}) => {
    const {
        onParamsChange,
        isDataReady,
        refetch,
        data,
        loadData,
    } = useRequestTable<{ data: OpportunityFilterRequestResponse[] }>({
        key: RequestKeys.getOpportunitiesByAccount,
        params: {},
        defaultValue: {
            data: {
                filters,
            },
            filter: {
                accountId: [accountId],
            },
            sort: {
                field: 'opportunityNumber',
                direction: 'asc',
            },
            rows: 200,
        },
        config: requests.FilterRequest,
        keepPreviousData: true,
        enabled: Boolean(accountId),
    })

    return {
        onParamsChange,
        isDataReady,
        refetch,
        data: data?.data,
        loadData,
    }
}
